

/**
 * ✅ Converts any date string (like "3/10/2025, 10:57")
 * or ISO date ("2025-10-03T10:57") to
 * ISO format for <input type="datetime-local"> (YYYY-MM-DDTHH:mm)
 */
export const convertToInputDateFormat = (value?: string): string => {
  if (!value) return "";

  // Already valid datetime-local format
  if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(value)) {
    return value.slice(0, 16);
  }

  const date = new Date(value);
  if (!isNaN(date.getTime())) {
    // Convert to local time (not UTC)
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  // Handle formats like "3/10/2025, 10:57"
  const [datePart, timePart] = value.split(", ");
  if (!datePart || !timePart) return "";

  const [day, month, year] = datePart.split("/");
  if (!day || !month || !year) return "";

  return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}T${timePart}`;
};

/**
 * ✅ Converts ISO datetime ("2025-10-03T10:57") or any date
 * to user-friendly display format (DD/MM/YYYY, 24-hour HH:mm)
 */
export const convertToDisplayDateFormat = (value?: string): string => {
  if (!value) return "";

  const date = new Date(value);
  if (isNaN(date.getTime())) return "";

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year}, ${hours}:${minutes}`;
};

/**
 * ✅ Normalize datetime-local input (user-entered)
 * to ISO 24-hour local format (YYYY-MM-DDTHH:mm)
 */
export const normalizeInputDate = (value: string): string => {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${year}-${month}-${day}T${hours}:${minutes}`;
};